import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import * as awsui from "@cloudscape-design/design-tokens";
import FRG_Rules from "../../frg-rules";

interface rulesHrefObj { [key: string]: string }


export default function Rules() {
  const { 
    activeSeriesName, setActiveSeriesName,
    activeSeriesRef, setActiveSeriesRef,
  } = useContext(GlobalContext);


  const FFA_Rules = () => {
    return (
      <>
        <h4>1. GENERAL REQUIREMENTS</h4>
        <p><b>All entrants must be located in Australia or New Zealand and have an SR of D2.0 or better.</b></p><br />
        <p><b>All entrants must become a member of the 'FRG' League</b></p>
        <p>Apply via iRacing - Search for 'FRG' via League Directory and apply to join.</p><br />
        <p><b>All entrants must become a member of the FRG Discord</b></p>
        <p>Discord link - https://discord.gg/unEfBYXquy</p>
        <p>Go to Discord and #choose-your-series channel and click the 'FFA' button to unlock the FFA Channel.</p>
        <h4>2. VEHICLES & SETUPS</h4>
        <h5>2.1 FORMULA FORD</h5>
        <p>The iRacing Ray GR22 Formula Ford vehicle will be used for this class of racing.</p>
        <br />
        <h5>2.2 SETUPS</h5>
        <p>The <b>FFA | E-Series</b> will feature fixed setups.</p>
        <p>The setups will vary from round to round depending on the circuit.</p>
        <p>Setups can be found in the Discord at <b>#ffa-Setups</b></p>
        <h4>3. RACE CALENDAR</h4>
        <p>The FFA | E-Series will consist of 10 rounds on Tuesday Nights.</p>
        <ul>
          <li>Round 1 - 30 May Winton</li>
          <li>Round 2 - 27 June Mid-Ohio</li>
          <li>Round 3 - 25 July monza</li>
          <li>Round 4 - 08 Aug Sandown</li>
          <li>Round 5 - 29 Aug Oran Park</li>
          <li>Round 6 - 19 Sept Phillip Island</li>
          <li>Round 7 - 24 Oct Road Atlanta</li>
          <li>Round 8 - 31 oct Pukekohe</li>
          <li>Round 9 - 14 Nov Brands Hatch</li>
          <li>Round 10 - 12 DEC Silverstone</li>
        </ul>
        <p><b>NOTE:</b> The final two rounds of the series may be based around the Formula Ford Festival at Brands Hatch and The Walter Hayes Trophy at Silverstone.</p>
        <p>The exact format of these events will be released at a later date when we havea better idea of the expected number of competitors.</p>
      </>
    )
  }


  return (
    <center>
      <div style={{ width: "100%" }}>
        <div data-rules className="body-content" style={{ maxWidth: "1200px", textAlign: "left" }}> 
        <Tabs
          tabs={[
            {
              label: "FRG League Rules",
              id: "frgRules",
              content: <FRG_Rules />
            },
            // {
            //   label: "Formula Ford Series Rules",
            //   id: "ffaRules",
            //   content: <FFA_Rules />
            // }
          ]}
        />          
        </div>
      </div>
    </center>
  );
}

